import React from "react";
import { TrendingUp, TrendingDown, ShieldCheck } from "lucide-react";

// Small original CSS/SVG bull / bear / shield holographic treatment
export default function BiasGraphic({ direction = "WAIT", size = 64 }) {
  const bull = direction === "LONG";
  const bear = direction === "SHORT";
  const shield = direction === "NO TRADE";
  const conflict = direction === "WAIT";

  const Item = ({ active, color, Icon }) => (
    <div className="grid place-items-center rounded-2xl relative"
      style={{
        width: size, height: size,
        background: active ? `radial-gradient(circle at 50% 35%, ${color}33, transparent 70%)` : "transparent",
        border: `1px solid ${active ? color + "66" : "var(--border)"}`,
        opacity: active ? 1 : 0.28,
        transition: "opacity .3s ease",
      }}>
      <Icon size={size * 0.44} color={color} strokeWidth={2} style={{ filter: active ? `drop-shadow(0 0 8px ${color}88)` : "none" }} />
      {active && <span className="live-dot absolute top-1.5 right-1.5" style={{ background: color }} />}
    </div>
  );

  if (shield) return <Item active color="#22d3ee" Icon={ShieldCheck} />;
  if (conflict)
    return (
      <div className="flex gap-2">
        <Item active color="#22c55e" Icon={TrendingUp} />
        <Item active color="#ef4444" Icon={TrendingDown} />
      </div>
    );
  return (
    <div className="flex gap-2">
      <Item active={bull} color="#22c55e" Icon={TrendingUp} />
      <Item active={bear} color="#ef4444" Icon={TrendingDown} />
    </div>
  );
}
